
export const isRassScaleKey = (scaleKey) =>
  typeof scaleKey === "string" && scaleKey.trim().toLowerCase() === "rass";

export const hasRassAssessmentInput = (data) => {
  if (!data || typeof data !== "object") return false;

  if (String(data.comments ?? "").trim().length > 0) return true;

  const v = data.rass_scale;
  if (v === "" || v === null || v === undefined) return false;
  const n = typeof v === "number" ? v : Number(v);
  return Number.isFinite(n);
};

